import { z } from 'zod';

/**
 * Activity node - represents interactions/communications
 * Renamed from Interaction for clarity
 */
export const ActivityPropsSchema = z.object({
  subject: z.string().min(1, 'Subject is required'),
  type: z.string().min(1, 'Type is required'),
  direction: z.enum(['inbound', 'outbound', 'bidirectional']),
  occurred_at: z.string().datetime(),
  summary: z.string().optional(),
  thread_id: z.string().optional(),
});

export type ActivityProps = z.infer<typeof ActivityPropsSchema>;
